import clsx from "clsx";
import { PropsWithRef } from "react";
import { Fact } from "./Fact";

import { ArrayElement, FeaturesContent as featuresText } from "@onzeit/shared";

export const FeaturesList = ({
  data,
  locale,
  pathName,
}: PropsWithRef<
  ArrayElement<typeof featuresText> & {
    pathName?: string | undefined;
    locale: string;
  }
>) => {
  let group = data.features!.find((x) => x.detailLink === pathName)!;
  if (!group) {
    group = data.features![0];
  }
  return (
    <ul className="mt-8 flex flex-col gap-8">
      <div
        key={group.detailLink}
        id={group.detailLink}
        className={clsx(
          "rounded-lg bg-gradient-to-bl p-4",
          group.sectionGradient,
        )}
      >
        <h2
          className={clsx(
            "bg-gradient-to-r bg-clip-text text-2xl font-bold text-transparent",
            "from-indigo-600 to-indigo-800",
          )}
        >
          {group.details.title}
        </h2>

        {/* Facts */}
        <>
          <div
            className={clsx(
              "my-4 h-[2px] rounded-3xl bg-gradient-to-b",
              "from-indigo-600/50 to-indigo-800/50",
            )}
          ></div>
          <div>
            <p className="mb-4 text-lg">{group.details.description}</p>
            <ul className="grid grid-cols-1 gap-8 xl:grid-cols-2">
              {group.details!.items!.map((item, index) => (
                <Fact key={`fact-${index}`} {...item} />
              ))}
            </ul>
          </div>
        </>
      </div>
    </ul>
  );
};
